import { IAccountBillTo } from '../models/account';
import { IResult } from '../models/result-models';
import { apiGet } from './api-utils';
import { IAccount } from '../models/company-account';

const baseUrl = process.env.REACT_APP_API_URL + '/v1/accounts';
const servicesBaseUrl = process.env.REACT_APP_SERVICES_URL + '/sessionAccount/';

export const getShipToAccounts = async (): Promise<IResult<IAccount[]>> => {
    const result = await apiGet<IAccount[]>(baseUrl + '/ship-to-accounts');
    return result;
};

export const getBillToAccounts = async (): Promise<
    IResult<IAccountBillTo[]>
> => {
    const result = await apiGet<IAccountBillTo[]>(
        baseUrl + '/bill-to-accounts'
    );
    return result;
};

export const getSessionAccount = async (): Promise<IResult<IAccount>> => {
    const result = await apiGet<IAccount>(baseUrl + '/session-ship-to-account');
    return result;
};
